import React from "react";
import "./LegalPages.css";

export default function DataProtection() {
  return (
    <div className="pp-legal-page">
      <div className="pp-container">
        <div className="pp-legal-shell">
          <div className="pp-legal-hero">
            <div className="pp-legal-badge">Data Protection</div>
            <h1>Clear data responsibility for school environments</h1>
            <p>
              PresentPlus is designed around school ownership, controlled access,
              role-based permissions and UK GDPR-aligned processing.
            </p>
          </div>

          <div className="pp-legal-summary">
            <div>
              <span>Controller</span>
              <strong>The school or organisation</strong>
            </div>
            <div>
              <span>Processor</span>
              <strong>PresentPlus / CoreLogic Systems Ltd</strong>
            </div>
            <div>
              <span>Security</span>
              <strong>Role-based access and audit visibility</strong>
            </div>
          </div>

          <div className="pp-legal-content">
            <section>
              <h2>Controller / Processor</h2>
              <p>
                Schools act as Data Controllers. PresentPlus acts as a Data Processor,
                processing data under the school’s instruction for school operations.
              </p>
            </section>

            <section>
              <h2>Security Measures</h2>
              <ul>
                <li>Role-based access control</li>
                <li>Secure authentication and MFA support</li>
                <li>School-level data isolation</li>
                <li>Audit logging for sensitive actions</li>
                <li>Encrypted data transmission and storage</li>
              </ul>
            </section>

            <section>
              <h2>Retention & Access</h2>
              <p>
                Access is limited by user role and school relationship. Retention should
                follow the school’s policy and agreed service terms.
              </p>
            </section>

            <section>
              <h2>Compliance</h2>
              <p>
                PresentPlus is operated in line with UK GDPR principles including data
                minimisation, access limitation, security and accountability.
              </p>
            </section>

            <section>
              <h2>Contact</h2>
              <p>For data protection questions, contact privacy@presentplus.uk.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
